<template>
  <div
    class="w-full flex flex-col  relative"
    :class="{'gap-3': isMobileOpen}"
  >
    <div class="block lg:hidden w-full">
      <button
        class="relative btn btn-red w-full flex flex-row justify-center items-center"
        @click="isMobileOpen = !isMobileOpen"
      >
        Kereső
        <img
          src="/img/icons/inputs/dropdown_arrow_icon.svg"
          class="h-[16px] w-[16px] absolute right-4 top-4 transform transition-all group-hover:text-gray-darkest duration-500 "
          :class="{ 
            'rotate-180': isMobileOpen,
          }"
        >
      </button>
    </div>

    <div 
      :class="{ 'max-h-[2000px] opacity-100': isMobileOpen}"
      class="w-full flex flex-col lg:flex-row gap-3 max-h-0 lg:max-h-full transition-all duration-500 opacity-0 lg:opacity-100"
    >
      <ReSelect
        v-model="form.date"
        :items="years"
        placeholder="Év"
        class="w-full lg:w-1/5"
        :has-errors="false"
        icon="/img/calendar_icon.svg"
      />
      <ReInput
        id="searchtext"
        v-model="form.text"
        placeholder="Keresendő szöveg"
        class="w-full lg:w-3/5"
        :has-errors="false"
        icon="/img/pen_icon.svg"
        type="text"
      />
      <div class="w-full lg:w-1/5">
        <button
          type="button"
          class="btn btn-red w-full"
          @click.prevent="submit"
        >
          <i class="fas fa-search" />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import ReInput from "~/components/rxt/reform/ReInput.vue";
import ReSelect from "~/components/rxt/reform/ReSelect.vue";

export default {
  components: {
    ReInput,
    ReSelect
  },
  props: {
    queryObject: {
      type: Object,
      default: () => {
        return {};
      }
    },
    propMapping: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  data() {
    return {
      isMobileOpen: false,
      showNav: false,
      form: {
        date: null,
        text: ""
      }
    };
  },
  computed: {
    years() {
      const years = [];

      for (let i = this.$moment().year(); i >= 1980; i--) {
        years.push(i);
      }

      return years.map(year => {
        return {
          key: this.$unique(),
          value: year,
          text: year
        };
      });
    }
  },
  watch: {
    queryObject(newData) {
      this.makeFormObjectFromQueryObject(newData);
    }
  },
  beforeMount() {
    this.makeFormObjectFromQueryObject(this.queryObject);
  },
  methods: {
    submit() {
      const queryObject = {};

      queryObject.limit = this.queryObject.limit ? this.queryObject.limit : 24;

      if (this.form.text) {
        queryObject["filter[search]"] = this.form.text;
      }
      if (this.form.date) {
        queryObject["filter[publication_year]"] = this.form.date;
      }

      this.$emit("searchChanged", queryObject);
      this.showNav = false;
    },
    calculateOffset() {
      return this.modules.length * 5;
    },

    makeFormObjectFromQueryObject(newData) {
      const form = {
        text: "",
        date: null
      };

      // set form params for eventsearch component
      if (newData["filter[search]"]) {
        form.text = newData["filter[search]"];
      }
      if (newData["filter[publication_year]"]) {
        form.date = newData["filter[publication_year]"];
      }

      this.form = form;
    }
  }
};
</script>